export default __webpack_public_path__ + "static/media/egranting-process.a82b85f1.png";